"use client";

import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function About() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="234433" id="quienessomos" className="py-32 bg-background text-foreground overflow-hidden">
            <div className="container mx-auto px-4 md:px-6">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 items-center">
                    {}
                    <div className="md:col-span-7 space-y-8">
                        <h2 className="font-default font-bold tracking-tighter uppercase text-primary !h-[56px] !text-6xl"><span className="text-white">NUESTRO</span> EQUIPO&nbsp;</h2>
                        
                        <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
                            <p><br />Después de 20 años como concesionario oficial en Cataluña comercializando y asistiendo técnicamente maquinaria de las marcas FIAT y HITACHI, nuestro equipo focalizó su experiencia y conocimientos en la venta de recambios de maquinaria HITACHI, FIAT, NEW HOLLAND, CASE, KOBELCO, DOOSAN y HYUNDAI. CONNECTING BARCELONA SL Forma parte de un grupo de empresas a nivel europeo, con almacenes centrales desde donde se envían diariamente los recambios a nuestros clientes. </p>
                        </div>

                        <div className="pt-4">
                            
                        </div>
                    </div>

                    {}
                    <div className="md:col-span-5">
                        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/spare_parts_warehouse.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/spare_parts_warehouse.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666184/img/spare_parts_warehouse.png-wvc-sizes" alt="Almacén de recambios para maquinaria pesada" className="w-full h-auto object-cover border-2 border-primary/20 rounded-md shadow-lg" loading="lazy" decoding="async" />
                        </div>
                    </div>
                </div>
            </div>
        </section>;
}